const allProducts = [
    {
    handle: "m1-stroller-wagon",
    generalFeatures: {
      seatCapacity: 1,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: false,
      adjustableCanopy: true,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: false,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: false,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: false,
      additionalStorage: true,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "200 lbs",
      seatCapacity: "60 lbs",
      frontWheelSize: '7.25"',
      rearWheelSize: '9.25"',
      productWeights: "50 lbs",
    },
  },
  {
    handle: "w4-stroller-wagon",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: false,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: false,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: false,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "300 lbs",
      seatCapacity: "99 lbs",
      frontWheelSize: '8"',
      rearWheelSize: '9.5"',
      productWeights: "24 kg",
    },
  },
  {
    handle: "w4-elite-stroller-wagon-4-seater",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: false,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: true,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: false,
      additionalStorage: true,
      magneticSeatbelts: false,
      singleRiderOption: true,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "300 lbs",
      seatCapacity: "99 lbs",
      frontWheelSize: '8"',
      rearWheelSize: '9.5"',
      productWeights: "25 kg",
    },
  },
  {
    handle: "w4-luxe-stroller-wagon-4-seater",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: true,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: true,
      additionalStorage: true,
      magneticSeatbelts: true,
      singleRiderOption: true,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "300 lbs",
      seatCapacity: "99 lbs",
      frontWheelSize: '10"',
      rearWheelSize: '12"',
      productWeights: "27.2 kg",
    },
  },
  {
    handle: "w2-stroller-wagon",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: false,
      adjustableCanopy: true,
      veganLeatherHandlebar: false,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: false,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "200 lbs",
      seatCapacity: "45 lbs",
      frontWheelSize: '7.5"',
      rearWheelSize: '9.5"',
      productWeights: "19 kg",
    },
  },
  {
    handle: "w2-elite-stroller-wagon",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: false,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: true,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: false,
      additionalStorage: true,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "200 lbs",
      seatCapacity: "45 lbs",
      frontWheelSize: '7.5"',
      rearWheelSize: '9.5"',
      productWeights: "21.3 kg",
    },
  },
  {
    handle: "w2-luxe-stroller-wagon",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: true,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: true,
      additionalStorage: true,
      magneticSeatbelts: true,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "200 lbs",
      seatCapacity: "45 lbs",
      frontWheelSize: '10"',
      rearWheelSize: '12"',
      productWeights: "24 kg",
    },
  },
  {
    handle: "w1-stroller-wagon",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: false,
      removableFabric: true,
      removableBasket: false,
      adjustableCanopy: true,
      veganLeatherHandlebar: false,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: false,
      zipperedDoor: false,
      sideMeshVentilation: false,
      adjustableCanopyRods: false,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: true,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "EVA",
      weightCapacity: "180 lbs",
      seatCapacity: "N/A",
      frontWheelSize: '7"',
      rearWheelSize: '9"',
      productWeights: "32 lbs",
    },
  },
  {
    handle: "x4-stroller-wagon",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: false,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: false,
      veganLeatherHandlebar: true,
      fitsThroughDoor: false
    },
    functionalFeatures: {
      pullPush: true,
      springBounceHandle: true,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: false,
      zipperedDoor: false,
      sideMeshVentilation: false,
      adjustableCanopyRods: true,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "180 lbs",
      seatCapacity: "N/A",
      frontWheelSize: '6.5"',
      rearWheelSize: '11"',
      productWeights: "41 lbs",
    },
  },
  {
    handle: "x4magneticbuckle",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: false,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: false,
      veganLeatherHandlebar: true,
      fitsThroughDoor: false
    },
    functionalFeatures: {
      pullPush: true,
      springBounceHandle: true,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: false,
      zipperedDoor: false,
      sideMeshVentilation: false,
      adjustableCanopyRods: true,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: true,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "180 lbs",
      seatCapacity: "N/A",
      frontWheelSize: '6.5"',
      rearWheelSize: '11"',
      productWeights: "41 lbs",
    },
  },
  {
    handle: "x2-stroller-wagon",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: false,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: false,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: true,
      springBounceHandle: true,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: false,
      zipperedDoor: false,
      sideMeshVentilation: false,
      adjustableCanopyRods: true,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: false,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "200 lbs",
      seatCapacity: "N/A",
      frontWheelSize: '6.5"',
      rearWheelSize: '11"',
      productWeights: "34 lbs",
    },
  },
  {
    handle: "x2-woodland-green",
    generalFeatures: {
      seatCapacity: 2,
      removableElevatedSeats: false,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: false,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: true,
      springBounceHandle: true,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: false,
      zipperedDoor: false,
      sideMeshVentilation: false,
      adjustableCanopyRods: true,
      recliningSeats: false,
      zipperedSideMeshPanels: false,
      xlAllTerainWheels: false,
      additionalStorage: false,
      magneticSeatbelts: true,
      singleRiderOption: false,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "150 lbs",
      seatCapacity: "N/A",
      frontWheelSize: '6.5"',
      rearWheelSize: '11"',
      productWeights: "34 lbs",
    },
  },
   {
    handle: "volkswagen",
    generalFeatures: {
      seatCapacity: 4,
      removableElevatedSeats: true,
      removableFabric: true,
      removableBasket: true,
      adjustableCanopy: true,
      veganLeatherHandlebar: true,
      fitsThroughDoor: true
    },
    functionalFeatures: {
      pullPush: false,
      springBounceHandle: false,
      adjustablePullHandle: true,
      bearingsInstalled: true,
      suspensionInstalled: true,
      footwell: true,
      zipperedDoor: true,
      sideMeshVentilation: true,
      adjustableCanopyRods: true,
      recliningSeats: true,
      zipperedSideMeshPanels: true,
      xlAllTerainWheels: true,
      additionalStorage: true,
      magneticSeatbelts: false,
      singleRiderOption: true,
      playpenConvertible: false,
    },
    safetyFeatures: {
      safetyLock: true,
      fivePointHarness: true,
      footbrake: true,
    },
    specs: {
      tireMaterial: "PU",
      weightCapacity: "300 lbs",
      seatCapacity: "99 lbs",
      frontWheelSize: '10"',
      rearWheelSize: '12"',
      productWeights: "30 kg",
    }
  }
];
